import { create } from "zustand";

export type DeviceLocation = { lat: number; lng: number };

interface LocationStore {
  location: DeviceLocation | null;
  updateLocation(location: DeviceLocation): void;
}

export const useLocationStore = create<LocationStore>((set) => ({
  location: null,
  updateLocation: (location: DeviceLocation) => set({ location }),
}));
